export default __webpack_public_path__ + "static/media/Decarbonise_Instructions_for_players.0ca7086a.pdf";